export default () => {
  const container = document.querySelector('.js-woo-filling-mat')
  if (!container) return

  const allOptions = container.querySelectorAll('.js-woo-filling-mat-option')
  const productLength = document.querySelector('.js-woo-length')
  const productWidth = document.querySelector('.js-woo-width')
  const optionError = container.querySelector('.js-woo-filling-mat-error')
  let defaultMatWidthContent = container.querySelector(
    '.js-woo-filling-mat-total-width'
  )
  let defaultMatWidth = parseInt(
    container.querySelector('.js-woo-filling-mat-total-width').dataset.width
  )

  ;[...allOptions].forEach(option => {
    option.addEventListener('click', e => {
      const matWidth = parseInt(option.dataset.width)

      setTimeout(() => {
        if (option.classList.contains('active')) {
          // option.classList.remove('active')
          defaultMatWidth = defaultMatWidth
            ? defaultMatWidth + matWidth
            : matWidth
        } else {
          // option.classList.add('active');
          defaultMatWidth = defaultMatWidth
            ? defaultMatWidth - matWidth
            : matWidth
        }

        defaultMatWidthContent.innerHTML = defaultMatWidth + 'mm'
      }, 500)

      if (productLength.value > 125 || productWidth.value > 125) {
        optionError.classList.add('active')
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/AddFillingMat.js